module.exports = __webpack_public_path__ + "assets/images/T-grey-icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/T-grey-icon.png
// module id = 392
// module chunks = 1